import React, { Component } from 'react';
import Btn from '../../components/btn';

export default class Intro extends Component {
	constructor(props) {
		super(props);
		this.state = {
			step: 0,
		};
	}

	render() {
		return (
			<div className='intro'>
				<div className='container'>
					<div className='intro__inner'>
						<h2 className='intro__title'>
							Попробуй, визуализируй <span>это</span>
						</h2>
						<div className='intro__text-wrap'>
							<div className='intro__text'>
								<b>Зачем?</b>
								<p>
								Мы сделали этот тренажер, чтобы развивать насмотренность в датавизе. Он поможет научиться правильно применять графики и не искажать информацию.
								</p>
							</div>
							<div className='intro__text'>
								<b>Что делать?</b>
								<p>
									Есть десять задач с описанием. Нужно выбрать тип графика,
									который визуально и логически подходит под это описание.
								</p>
							</div>
						</div>
						<Btn
							className='intro__btn'
							onClick={this.props.updatePage.bind(this, 2)}>
							Понятно!
						</Btn>
					</div>
				</div>
			</div>
		);
	}
}
